import React from 'react';
import { Button } from 'ui-components/components/button';
import { ordinalOfAnchorEndTag } from '../alert-description-helper';
import PropTypes from 'prop-types';

export const AnchorAtStartCustomAlert = ({ onClick, orderNumber, content = '' }) => {
  if (!content.length) {
    return null;
  }
  const startWhereTagEnds = ordinalOfAnchorEndTag(content);
  const contentWithoutAnchor = content.substring(startWhereTagEnds);
  return (
    <React.Fragment>
      <Button onClick={onClick} theme='link'>
        {orderNumber}
      </Button>
      {/* Have to do the markup like this or we get this error with <FormattedHTMLMessage /> 'Messages must be statically evaluate-able for extraction.' */}
      {/* oxlint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: contentWithoutAnchor }} />
    </React.Fragment>
  );
};

AnchorAtStartCustomAlert.propTypes = {
  onClick: PropTypes.func.isRequired,
  orderNumber: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
